var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckEsquina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#3FAB35;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M731.4,736H125.2V103.1h606.2V736z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1080,0c0,596.5-483.5,1080-1080,1080V0H1080z M378.6,702.1c9.3-0.4,17.9-5.1,23.3-12.7l299.6-425.8 c9.5-13.6,6.3-32.3-7.3-41.8s-32.3-6.3-41.8,7.3L375.3,622.9L246.2,468.8c-10.6-12.7-29.6-14.4-42.3-3.7 c-12.7,10.6-14.4,29.6-3.7,42.3l154.1,184c5.7,6.8,14.1,10.7,23,10.7C377.8,702.1,378.2,702.1,378.6,702.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,1090h-10v-20H0c590,0,1070-480,1070-1070v-10h20V0c0,147.1-28.8,289.9-85.7,424.3 c-27.3,64.6-61.1,126.9-100.5,185.2c-39,57.7-83.8,112-133.1,161.3s-103.6,94.1-161.3,133.1c-58.3,39.4-120.6,73.2-185.2,100.5 C289.9,1061.2,147.1,1090,0,1090z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEsquina);
export default __webpack_public_path__ + "static/media/check-esquina.9fb013f42422f5d7da409a26c23e96a5.svg";
export { ForwardRef as ReactComponent };